"use strict";

import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = function __decorateClass(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
import React from "react";
import { observer } from "mobx-react";
import IconButton from "../../pieces/IconButton/IconButton";
import { AnimationDuration } from "../../../styles/Animations";
import { Transition } from "react-transition-group";
import forceReflow from "../../../utils/forceReflow";
import { Tick, Delete, Warning, Close, Information } from "../../icons";
import { ButtonSize } from "../../pieces/Button/Button";
export var NotificationType = /* @__PURE__ */function (NotificationType2) {
  NotificationType2["Success"] = "success";
  NotificationType2["Error"] = "error";
  NotificationType2["Delete"] = "delete";
  NotificationType2["Info"] = "info";
  return NotificationType2;
}(NotificationType || {});
var Notification = /*#__PURE__*/function (_React$Component) {
  _inherits(Notification, _React$Component);
  var _super = _createSuper(Notification);
  function Notification() {
    _classCallCheck(this, Notification);
    return _super.apply(this, arguments);
  }
  _createClass(Notification, [{
    key: "render",
    value: function render() {
      var _this = this;
      return /* @__PURE__ */React.createElement(Transition, {
        timeout: AnimationDuration.Long,
        in: this.props.isShowing,
        onEnter: forceReflow,
        unmountOnExit: true,
        mountOnEnter: true
      }, function (status) {
        return /* @__PURE__ */React.createElement("div", {
          className: "notification notification--".concat(status),
          "aria-live": "polite"
        }, /* @__PURE__ */React.createElement("div", {
          className: "notification__icon notification__icon--".concat(_this.props.type, " center")
        }, _this.renderIcon), /* @__PURE__ */React.createElement("div", {
          className: "notification__body"
        }, _this.props.children), /* @__PURE__ */React.createElement("div", {
          className: "notification__close"
        }, /* @__PURE__ */React.createElement(IconButton, {
          icon: /* @__PURE__ */React.createElement(Close, null),
          "aria-label": "Close notification",
          onClick: _this.props.onClose,
          size: ButtonSize.Small
        })));
      });
    }
  }, {
    key: "renderIcon",
    get: function get() {
      if (this.props.type === "success" /* Success */) {
        return /* @__PURE__ */React.createElement(Tick, null);
      } else if (this.props.type === "delete" /* Delete */) {
        return /* @__PURE__ */React.createElement(Delete, null);
      } else if (this.props.type === "error" /* Error */) {
        return /* @__PURE__ */React.createElement(Warning, null);
      } else {
        return /* @__PURE__ */React.createElement(Information, null);
      }
    }
  }]);
  return Notification;
}(React.Component);
Notification.defaultProps = {
  type: "info" /* Info */
};

Notification = __decorateClass([observer], Notification);
export { Notification as default };